"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GenerateOut = void 0;
class GenerateOut {
    constructor() {
    }
    static getAttributeTypeMap() {
        return GenerateOut.attributeTypeMap;
    }
}
exports.GenerateOut = GenerateOut;
GenerateOut.discriminator = undefined;
GenerateOut.attributeTypeMap = [
    {
        "name": "choices",
        "baseName": "choices",
        "type": "Array<CompletionChoice>",
        "format": ""
    },
    {
        "name": "created",
        "baseName": "created",
        "type": "number",
        "format": "int64"
    },
    {
        "name": "id",
        "baseName": "id",
        "type": "string",
        "format": ""
    },
    {
        "name": "model",
        "baseName": "model",
        "type": "string",
        "format": ""
    },
    {
        "name": "object",
        "baseName": "object",
        "type": "string",
        "format": ""
    }
];
//# sourceMappingURL=GenerateOut.js.map